import React from 'react';

type Props = React.SVGProps<SVGSVGElement> & {
  disabled?: boolean;
};

const Copy = ({ disabled, ...props }: Props): JSX.Element => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3H18C19.1046 3 20 3.89543 20 5V15C20 16.1046 19.1046 17 18 17H16V19C16 20.1046 15.1046 21 14 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H8V5C8 3.89543 8.89543 3 10 3ZM16 15V9C16 7.89543 15.1046 7 14 7H10V5H18V15H16ZM7 14.5C6.72386 14.5 6.5 14.2761 6.5 14C6.5 13.7239 6.72386 13.5 7 13.5H9.5V11C9.5 10.7239 9.72386 10.5 10 10.5C10.2761 10.5 10.5 10.7239 10.5 11V13.5H13C13.2761 13.5 13.5 13.7239 13.5 14C13.5 14.2761 13.2761 14.5 13 14.5H10.5V17C10.5 17.2761 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.2761 9.5 17V14.5H7Z"
      fill={disabled ? '#a0abb8' : '#0073F7'}
    />
  </svg>
);

export default Copy;
